const $ = window.$
$(function(){
    var parentClassSelector = '.floatlabel';
    var focusedClass = "floatlabel-focused";
    var activeClass = "floatlabel-active";

    // Check initial vals
    $(parentClassSelector+' input,' + parentClassSelector+' textarea').each(function() {
        if ($(this).val() == '') {
            $(this).parents(parentClassSelector).removeClass(activeClass)
        } else {
            $(this).parents(parentClassSelector).addClass(activeClass)
        }
    });
    $(parentClassSelector+' input,' + parentClassSelector+' textarea').on("focus", function(event) {
        $(this).parents(parentClassSelector).addClass(focusedClass)
    });
    $(parentClassSelector+' input,' + parentClassSelector+' textarea').on("blur", function(event) {
        $(this).parents(parentClassSelector).removeClass(focusedClass)
    });
    $(parentClassSelector+' input,' + parentClassSelector+' textarea').on("keyup blur change input", function(event) {
        if ($(this).val() == '') {
            $(this).parents(parentClassSelector).removeClass(activeClass)
        } else {
            $(this).parents(parentClassSelector).addClass(activeClass)
        }
    });
});
